import ContactGrid from 'components/ContactGrid'

const Contact = () => {
  return <ContactGrid />
}

export default Contact
